import BorderlessButton from "@components/BorderlessButton/BorderlessButton";
import Carousel from "@components/Carousel/Carousel";
import Header from "@components/Header/Header"
import { JagadLogo } from "@components/JagadLogo/JagadLogo";
import PrimaryButton from "@components/PrimaryButton/PrimaryButton";
import { ButtonGroup, CarouselContainer, OnBoardingContainer } from "./OnBoarding.styles";
import carouselImg1 from "@assets/images/CarouselImg1.png";
import carouselImg2 from "@assets/images/CarouselImg2.png";
import carouselImg3 from "@assets/images/CarouselImg3.png";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { setHeaderColor } from "@lib/telegram";
import { WHITE } from "@styles/colors";

const OnBoarding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [pendingAction, setPendingAction] = useState<'login' | 'create' | null>(null);

  const defaultSlides = [
    {
      id: 1,
      image: carouselImg1,
      title: t('page.onboarding.carousel.slide1.title'),
      description: t('page.onboarding.carousel.slide1.description')
    },
    {
      id: 2,
      image: carouselImg2,
      title: t('page.onboarding.carousel.slide2.title'),
      description: t('page.onboarding.carousel.slide2.description')
    },
    {
      id: 3,
      image: carouselImg3,
      title: t('page.onboarding.carousel.slide3.title'),
      description: t('page.onboarding.carousel.slide3.description')
    },
  ];


  const handleCreateWallet = () => {
    navigate("/create");
  };




  useEffect(() => {
    setHeaderColor(WHITE)
  }, [])

  return (
    <OnBoardingContainer>
      <Header>
        <JagadLogo type="logo-color-text-black" size={30} />
      </Header>
      <CarouselContainer>
        <Carousel slides={defaultSlides} autoplayInterval={3500} />
      </CarouselContainer>
      <ButtonGroup>
        <PrimaryButton onClick={handleCreateWallet} fullWidth={true}>{t('page.onboarding.create')}</PrimaryButton>
        <BorderlessButton onClick={() => navigate("/login")}>{t('page.onboarding.login')}</BorderlessButton>
      </ButtonGroup>

    </OnBoardingContainer>
  )
}

export default OnBoarding
